// constants
import { SELECTORS } from '@/scripts/constants';

// other
import { controller } from '@/scrollmagic/controller';

export function headerToggle() {
  const header = document.querySelector('header');
  if (!header) {
    return null;
  }

  let currentScroll = 0;
  return new ScrollMagic.Scene({
    triggerElement: document.body,
    triggerHook: 'onLeave',
    offset: 30,
  })
    .setClassToggle(header, SELECTORS.active)
    .on('update', (e) => {
      const { scrollPos } = e;
      if (Math.abs(scrollPos - currentScroll) > 80) {
        const direction = controller.info('scrollDirection');
        currentScroll = scrollPos;
        header.classList.toggle(SELECTORS.hidden, direction === 'FORWARD');
      }
    })
    .addTo(controller);
}
